import React from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  return <section className="py-20 md:py-28 bg-[#111111] text-[#FAF7F2]" data-id="element-251">
      <div className="max-w-3xl mx-auto px-4" data-id="element-252">
        <div className="space-y-8" data-id="element-253">
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-254">
            <p className="text-2xl md:text-3xl font-serif text-[#FAF7F2] leading-tight" data-id="element-255">
              La mayoría de las parejas
            </p>
            <p className="text-2xl md:text-3xl font-bold font-serif text-[#B91C1C] mt-1" data-id="element-256">
              Se separa por desconexión progresiva.
            </p>
          </motion.div>

          <motion.div className="text-lg md:text-xl text-[#FAF7F2]/70 font-light leading-relaxed space-y-1" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-257">
            <p data-id="element-258">Primero baja la frecuencia.</p>
            <p data-id="element-259">Después baja la curiosidad.</p>
            <p data-id="element-260">Después baja la admiración.</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="space-y-1" data-id="element-261">
            <p className="text-xl md:text-2xl text-[#FAF7F2]/90 font-serif" data-id="element-262">
              Y un día te das cuenta…
            </p>
            <p className="text-xl md:text-2xl text-[#FAF7F2] font-bold font-serif" data-id="element-263">
              que ya no se buscan igual.
            </p>
          </motion.div>

          <div className="w-full h-px bg-[#C5A55A]/20 my-6" data-id="element-264"></div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-265">
            <p className="text-xl md:text-2xl text-[#FAF7F2]/80 font-light" data-id="element-266">
              Eso no empieza en la traición.
            </p>
            <p className="text-xl md:text-2xl text-[#FAF7F2] font-bold mt-1" data-id="element-267">
              Empieza en la rutina.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}